import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Checkbox } from '@mui/material';

//Material-Ui Checkbox component with correct color in svg
const StyledCheckbox = styled(Checkbox)`
  && {
    &.checked svg {
      color: ${({ color, theme }) => theme.palette[color].main};
    }
  }
`;

StyledCheckbox.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary']).isRequired
};

export default StyledCheckbox;
